import { Box } from '@mui/material';
import { useState, useEffect } from 'react';
import { Button } from '../../components/common';
import DataGrid from '../../components/DataGrid/DataGrid';
import EditParametersPlantsModal from '../../components/Modals/ParametersModals/EditParametersPlantsModal';
import ParametersWarningModal from '../../components/Modals/ParametersModals/ParametersWarningModal';
import { incomeParameters } from '../../utils/api';
import { columns } from './parametersPlantsConsts';

export default function ParametersPlants(props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [warningModalOpen, setWarningModalOpen] = useState(true);
  const [selection, setSelection] = useState([]);
  const [selectionData, setSelectionData] = useState([]);
  const [data, setData] = useState();

  const warningConfirm = () => {
    setWarningModalOpen(false);
  };

  const updateParameters = () => {
    incomeParameters
      .crop()
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    updateParameters();
    //eslint-disable-next-line
  }, []);

  const handleSelectionChange = (newSelection) => {
    setSelection(newSelection);
    const selectionDataFiltered = data?.filter((param) => {
      if (newSelection.includes(param.id)) return param;
      else return null;
    });
    setSelectionData(selectionDataFiltered);
  };

  useEffect(() => {
    handleSelectionChange(selection);
    //eslint-disable-next-line
  }, [data]);

  return (
    <>
      <Box sx={{ mt: 10 }}>
        <Button
          variant="contained"
          onClick={() => setModalOpen(true)}
          disabled={!(selection.length > 0)}
        >
          EDYTUJ WSKAŹNIK
        </Button>
        <DataGrid
          toolbar
          checkboxSelection
          multiselect={false}
          columnData={columns}
          rowData={data?.sort((a, b) => a.id - b.id)}
          sx={{ boxShadow: 3 }}
          onSelectionModelChange={handleSelectionChange}
          selectionModel={selection}
          getRowHeight={() => 'auto'}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />
      </Box>
      {modalOpen && (
        <EditParametersPlantsModal
          open={modalOpen}
          setOpen={setModalOpen}
          selected={selection}
          selectionData={selectionData}
          updateParameters={updateParameters}
        />
      )}
      {warningModalOpen && (
        <ParametersWarningModal
          open={warningModalOpen}
          setOpen={setWarningModalOpen}
          confirm={warningConfirm}
        />
      )}
    </>
  );
}
